export const ordersAdminStrings = {
    loading: 'Loading orders...',
    signedOut: 'Sign in to manage print orders.',
    loginFailed: 'The username or password is incorrect.',
    requestFailed: 'The request could not be completed.',
    shopDisabled: 'The print shop is not enabled. Orders appear here once it is turned on.',
    noOrders: 'No orders match the current filters.',
    syncing: 'Checking Stripe for missed payments...',
    syncResult: (checked: number, imported: number) => imported === 0
        ? `Checked ${checked} recent Stripe payment${checked === 1 ? '' : 's'}; every one already has an order.`
        : `Imported ${imported} missed order${imported === 1 ? '' : 's'} from ${checked} recent Stripe payment${checked === 1 ? '' : 's'}. Check that the webhook is delivering.`,
    open: (orderNumber: string) => `Open order ${orderNumber}`,
    pageSummary: (page: number, totalPages: number, totalCount: number) =>
        totalCount === 0 ? 'No results' : `Page ${page} of ${totalPages} · ${totalCount} order${totalCount === 1 ? '' : 's'}`,
    shipBy: (date: string) => `Ship by ${date}`,
    overdue: 'Overdue',
    dueToday: 'Due today',
    reprintOf: (orderNumber: string, reason: string | null) =>
        `Free reprint of ${orderNumber}${reason == null || reason.length === 0 ? '' : ` — ${reason}`}`,
    reprintsCreated: (orderNumbers: string[]) => `Reprints: ${orderNumbers.join(', ')}`,
    printList: 'Print list',
    shipTo: 'Ship to',
    copyAddress: 'Copy address',
    copyFileName: (fileName: string) => `Copy ${fileName}`,
    copied: 'Copied.',
    copyFailed: 'Copy failed. Select the text instead.',
    fileNameMissing: 'File name not recorded',
    totals: 'Totals',
    timeline: 'Timeline',
    paid: 'Paid',
    created: 'Created',
    cameFrom: 'Came from',
    shipByLabel: 'Ship by',
    printed: 'Printed',
    shipped: 'Shipped',
    delivered: 'Delivered',
    returnDeadline: 'Return deadline',
    refunded: 'Refunded',
    refundedLate: 'Refunded after the return deadline.',
    confirmationEmail: 'Confirmation email',
    reprintEmail: 'Reprint email',
    reprintStatus: 'Reprint',
    shippedEmail: 'Shipped email',
    notSent: 'Not sent',
    markPrinted: 'Mark printed',
    markShipped: 'Mark shipped',
    updateTracking: 'Update tracking',
    carrier: 'Carrier',
    trackingNumber: 'Tracking number',
    markDelivered: 'Mark delivered',
    deliveredDate: 'Delivered on',
    reprintHeading: 'Damaged in transit',
    reprintReason: 'Reason',
    reprintPlaceholder: 'e.g. crushed tube, customer photo received 10/14',
    sendReprint: 'Send free reprint',
    confirmReprint: (orderNumber: string) => `Create a free reprint of ${orderNumber} and email the customer?`,
    resendConfirmation: 'Resend confirmation',
    notes: 'Admin notes',
    saveNotes: 'Save notes',
    stripePayment: 'View payment in Stripe',
    refundHint: 'Refunds are issued in the Stripe dashboard; the order updates automatically.',
    markedPrinted: 'Marked printed.',
    markedShipped: 'Marked shipped. The customer has been emailed.',
    trackingUpdated: 'Tracking updated.',
    markedDelivered: 'Delivery date saved.',
    reprintCreated: (orderNumber: string) => `Reprint ${orderNumber} created and the customer emailed.`,
    confirmationResent: 'Confirmation email sent.',
    notesSaved: 'Notes saved.',
    status: {
        paid: 'Paid',
        printed: 'Printed',
        shipped: 'Shipped',
        refunded: 'Refunded',
        canceled: 'Canceled'
    } as Record<string, string>
} as const;
